import {Component, OnInit} from '@angular/core';
import {IonicModule, ModalController, ToastController, ActionSheetController} from "@ionic/angular";
import {Observable, tap} from "rxjs";
import {AukceImage} from "../models/aukceImage";
import {ApiService} from "../services/api.service";
import {AuthService} from "../services/auth.service";
import {DataService} from "../services/data.service";
import {CountdownService} from "../services/countdown.service";
import {AdminPage} from "../admin/admin.page";
import {AsyncPipe, NgForOf, NgIf} from "@angular/common";
import {CountdownComponent, CountdownConfig, CountdownEvent} from "ngx-countdown";
import {ReadMoreComponent} from "../components/readmore/readmore.component";
import {LoginPage} from "../login/login.page";
import {PrihoditPage} from "../prihodit/prihodit.page";
import {logOutOutline, menu, personCircle, personCircleOutline, personOutline} from 'ionicons/icons'
import {RouterLink, Router} from "@angular/router";
import { addIcons } from 'ionicons';

addIcons({
  'menu': menu,
  'person-circle-outline': personCircleOutline,
  'person-outline': personOutline,
  'log-out-outline': logOutOutline
});

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
  standalone: true,
  imports: [
    IonicModule,
    NgIf,
    CountdownComponent,
    ReadMoreComponent,
    AsyncPipe,
    NgForOf,
    RouterLink
  ],
})
export class HomePage implements OnInit {
  photos$!: Observable<AukceImage[]>
  loading: boolean = true;

  private prihoditModal!: HTMLIonModalElement;
  prihoditBtnDisabled: boolean = false

  constructor(
    private modalCtrl: ModalController,
    private actionSheetController: ActionSheetController,
    private router: Router,
    public api: ApiService,
    public toast: ToastController,
    public authService: AuthService,
    public dataService: DataService,
    public countdownService: CountdownService
    ) {
    }

    ngOnInit() {
      this.loadPhotos();
    }

    loadPhotos() {
      this.loading = true;
      this.photos$ = this.dataService.getPhotos().pipe(
        tap(e => {
          console.log('AukceImages', e)
          this.loading = false;
        })
      )
    }

    // called from prihoditPage modal
  async prihodit(photo: AukceImage, prihoz: number) {
    console.log('prihodit', photo, prihoz)

    if (this.countdownService.isAuctionEnded()) {
      await this.showToast('Aukce již skončila. Není možné přihazovat.')
      return
    }

    prihoz = Number(prihoz)
    if (Number.isInteger(prihoz)) {
      photo.currentPrice = prihoz
      // this.parentPrihodit(this.photo, prihoz)
    }
    if (this.authService.loggedIn) {
      if (photo['priceHistory'] == undefined) {
        photo['priceHistory'] = {}
        await this.updatePriceHistory(prihoz, photo)
        this.dismissPrihoditModal()
        await this.showPrihodilToast(prihoz)
      } else {
        let recipient = photo['priceHistory'][Math.max.apply(null, (Object.keys(photo.priceHistory).map(Number)))]
        if (await this.prehodilSamSebe(recipient)) {
          await this.updatePriceHistory(prihoz, photo)
          this.dismissPrihoditModal()
          await this.showPrihodilToast(prihoz, photo.currentTopper.name)
        } else {
          this.api.sendBylJsiPrehozenEmail(photo, prihoz, recipient).subscribe(async () => {
            await this.updatePriceHistory(prihoz, photo)
            this.dismissPrihoditModal()
            await this.showPrihodilToast(prihoz, photo.currentTopper.name)
          })
        }
      }

    }
  }

  async prehodilSamSebe(recipient: string) {
    return (await this.authService.getAuth().currentUser)?.email == recipient
  }

  async updatePriceHistory(prihoz: number, photo: AukceImage) {
    const email = (await this.authService.getAuth().currentUser)?.email
    if (email) {
      photo['priceHistory'][prihoz] = email
    }
    console.log('updatePriceHistory', photo, prihoz);
    await this.dataService.updatePhotoPrice(photo.id, {priceHistory: photo.priceHistory, currentPrice: prihoz})
  }

  countdownToStartConfig: CountdownConfig = {
    stopTime: this.countdownService.AUCTION_START.getTime(),
    format: ' H:mm:ss'
  }
  countdownToEndConfig: CountdownConfig = {
    stopTime: this.countdownService.AUCTION_END.getTime(),
    format: ' H:mm:ss'
  }

  isLoggedIn() {
    return this.authService.isLoggedIn()
  }
  getCurrentUser() {
    return this.authService.getCurrentUser()
  }
  getCurrentUserNickname() {
    return this.authService.getCurrentUserNickname()
  }

  dismissPrihoditModal() {
    console.log('dismissPrihoditModal');
    this.prihoditModal.dismiss()
  }

  async showPrihoditModal(photo: AukceImage) {
    this.prihoditModal = await this.modalCtrl.create({
      component: PrihoditPage,
      cssClass: "prihodit-modal",
      componentProps: {
        photo: photo,
        prihodit: this.prihodit.bind(this),
        // googleLogin: this.googleLogin.bind(this),
        // emailLogin: this.emailLogin.bind(this),
        // facebookLogin: this.facebookLogin.bind(this)
      }
    });
    // console.log(photo)
    return await this.prihoditModal.present()
  }

  showPrihoditOrLogin(photo: AukceImage) {
    // console.log(ev)
    if (this.authService.loggedIn) {
      this.showPrihoditModal(photo)
    } else {
      this.showLoginModal()
    }
  }

  async showLoginModal() {
    const modal = await this.modalCtrl.create({
      component: LoginPage,
      cssClass: "login-modal",
    });
    return await modal.present()
  }

  countdownFinished() {
    this.countdownService.startAuction()
  }

  private async showPrihodilToast(prihoz: any, previousTopper?: string) {
    const toast = await this.toast.create({
      message:  `Přehodil/a jste nejvyšší nabídku od ${previousTopper} částkou ${prihoz} Kč.`,
      duration: 6000,
      position: 'bottom'
    })
    await toast.present()
  }

  private async showToast(message: string) {
    const toast = await this.toast.create({
      message,
      duration: 6000,
      position: 'bottom'
    })
    await toast.present()
  }

  login() {
    this.showLoginModal()
  }
  logout() {
    this.authService.logout()
  }

  isAdmin() {
    // return false
    return this.authService.isAdmin
  }

  async showAdminModal() {
    const modal = await this.modalCtrl.create({
      component: AdminPage,
      cssClass: 'admin-modal',
      breakpoints: [0, 0.5, 0.8, 1],
      initialBreakpoint: 1,
    });
    return await modal.present();
  }

  async openMobileMenu() {
    const actionSheet = await this.actionSheetController.create({
      header: 'Možnosti',
      buttons: [
        {
          text: this.isLoggedIn() ? 'Můj profil' : 'Přihlásit / Registrovat',
          icon: this.isLoggedIn() ? 'person-outline' : 'person-circle-outline',
          handler: () => {
            if (this.isLoggedIn()) {
              this.router.navigate(['/profile']);
            } else {
              this.showLoginModal();
            }
          }
        },
        {
          text: this.isLoggedIn() ? 'Odhlásit' : 'Zrušit',
          icon: this.isLoggedIn() ? 'log-out-outline' : 'close-outline',
          role: this.isLoggedIn() ? 'destructive' : 'cancel',
          handler: () => {
            if (this.isLoggedIn()) {
              this.logout();
            }
          }
        },
        {
          text: 'Zrušit',
          icon: 'close',
          role: 'cancel'
        }
      ]
    });

    await actionSheet.present();
  }

  countdownChanged(event: CountdownEvent) {
    if (event.action === "done") this.countdownFinished()
  }
}
